module.exports = __webpack_public_path__ + "hbomaxar-static/media/LiquidTrip_SmallLoop_00074.604acc5f.png";